import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet, doAsyncPost, doAsyncPut } from '@/api/async-util'

const types = {
    GET_EMAIL_AVAILABLE: createAsyncMutation('GET_EMAIL_AVAILABLE'),
    GET_EMAIL: createAsyncMutation('GET_EMAIL'),
    GET_ACCOUNT_INFO: createAsyncMutation('GET_ACCOUNT_INFO'),
    VALIDATE_RESET_TOKEN: createAsyncMutation('VALIDATE_RESET_TOKEN'),
    IS_EMAIL_CONFIRMED: createAsyncMutation('IS_EMAIL_CONFIRMED'),
    FORGOT_PASSWORD: createAsyncMutation('FORGOT_PASSWORD'),
    RESET_PASSWORD: createAsyncMutation('RESET_PASSWORD'),
    RESEND_CONFIRM_EMAIL: createAsyncMutation('RESEND_CONFIRM_EMAIL'),
    CONFIRM_EMAIL: createAsyncMutation('CONFIRM_EMAIL'),
    POST_NEW_ACCOUNT: createAsyncMutation('POST_NEW_ACCOUNT'),
    CHANGE_PASSWORD: createAsyncMutation('CHANGE_PASSWORD'),
    UPDATE_ACCOUNT_INFO: createAsyncMutation('UPDATE_ACCOUNT_INFO'),
}

const account = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getEmailAvailable(store, payload) {
            let url = api.account + 'Available'
            if (payload)
                url += '?email=' + payload

            return doAsyncGet(store, { url, mutationTypes: types.GET_EMAIL_AVAILABLE })
        },
        getEmailById(store, id) {
            let url = api.account + 'UserName'
            if (id)
                url += '?id=' + id
            return doAsyncGet(store, { url, mutationTypes: types.GET_EMAIL })
        },

        getAccountInfoByEmail(store, payload) {
            let url = api.account + 'Email/'
            if (payload)
                url += '?email=' + payload
            return doAsyncGet(store, { url, mutationTypes: types.GET_ACCOUNT_INFO })
        },

        validateResetToken(store, payload) {
            let url = api.account + 'ValidateResetToken'
            if (payload)
                url += '?userId=' + payload.userId + '&token=' + payload.token
            return doAsyncGet(store, { url, mutationTypes: types.VALIDATE_RESET_TOKEN })
        },
        isEmailConfirmed(store, email) {
            let url = api.account + 'Confirmed?email=' + email
            return doAsyncGet(store, { url, mutationTypes: types.IS_EMAIL_CONFIRMED })
        },

        // POST
        resendConfirmEmail(store, payload) {
            let url = api.account + 'ResendConfirmEmail'
            return doAsyncPost(store, { url, mutationTypes: types.RESEND_CONFIRM_EMAIL, payload })
        },
        confirmEmail(store, payload) {
            let url = api.account + 'ConfirmEmail'
            return doAsyncPost(store, { url, mutationTypes: types.CONFIRM_EMAIL, payload })
        },
        forgotPassword(store, payload) {
            let url = api.account + 'ForgotPassword'
            return doAsyncPost(store, { url, mutationTypes: types.FORGOT_PASSWORD, payload })
        },

        resetPassword(store, payload) {
            let url = api.account + 'ResetPassword'
            return doAsyncPost(store, { url, mutationTypes: types.RESET_PASSWORD, payload })
        },

        changePassword(store, payload) {
            let url = api.account + 'ChangePassword'
            return doAsyncPost(store, { url, mutationTypes: types.CHANGE_PASSWORD, payload })
        },

        postNewAccount(store, payload) {
            let url = api.account + 'Register'
            return doAsyncPost(store, { url, mutationTypes: types.POST_NEW_ACCOUNT, payload })
        },

        // PUT
        updateAccountInfo(store, payload) {
            let url = api.account + 'Update/'
            return doAsyncPut(store, { url, mutationTypes: types.UPDATE_ACCOUNT_INFO, payload })
        },
    },
    getters: {},
    types: types
}

export default account
